import { webhookRequest } from "@/api/webhook_request";
import { getField, updateField } from 'vuex-map-fields';


export const SET_LIST = "SET_LIST";
export const SET_LOADING = "SET_LOADING";
export const SET_LIMIT = "SET_LIMIT";
export const SET_OFFSET = "SET_OFFSET";
export const SET_COMPANYDB = "SET_COMPANYDB"

class WebhookRequestList {
    constructor() {
        this.count = 0;
        this.next = undefined;
        this.previous = undefined;
        this.companydb_id = undefined;
        this.results = [];
        this.limit = 10;
        this.offset = 0;
        this.headers = [
            {
                text: 'Fecha',
                value: 'create_datetime',
                sortable: false
            },
            {
                text: 'Estado',
                value: 'state',
                sortable: false
            },
            {
                text: 'URL',
                value: 'url',
                sortable: false
            },
            {
                text: 'Código',
                value: 'code',
                sortable: false
            },
            {
                text: 'Respuesta',
                value: 'response',
                sortable: false
            },
            
        ];
        this.loading = false;
    }
}

const models = {
    WebhookRequestList
};

const defaultData = new WebhookRequestList();

const state = () => ({
    list: defaultData,
});

const getData = ({ commit, dispatch, state, rootGetters, rootState }, { company_id }) => {
    return new Promise((resolve, reject) => {
        commit(SET_LOADING, true);
        commit(SET_COMPANYDB, company_id)
        webhookRequest.getData({companydb_id: company_id, limit: state.list.limit, offset: state.list.offset}).then(response => {
            commit(SET_LIST, response.data);
            commit(SET_LOADING, false);
            resolve();
        }).catch(err => {
            console.error(err);
            commit(SET_LOADING, false);
            reject();
        });
    });
};

const getItemPerPage = ({commit, dispatch, state, rootGetters, rootState}, values) => {
    commit(SET_LIMIT, values);
    commit(SET_OFFSET, 0);
    getData({commit, dispatch, state, rootGetters, rootState}, {company_id: state.list.companydb_id});
}

const setPage = ({commit, dispatch, state, rootGetters, rootState}, page) => {
    let offset = (page - 1) * state.list.limit;
    commit(SET_OFFSET, offset);
    getData({commit, dispatch, state, rootGetters, rootState}, {company_id: state.list.companydb_id});
}

export const actions = {
    getData,
    getItemPerPage,
    setPage
}

const mutations = {
    updateField,
    [SET_LIST](state, list) {
        state.list.count = list.count;
        state.list.next = list.next;
        state.list.previous = list.previous;
        state.list.results = list.results;
    },
    [SET_LOADING](state, loading) {
        state.list.loading = loading;
    },
    [SET_LIMIT](state, limit) {
        state.list.limit = limit;
    },
    [SET_OFFSET](state, offset) {
        state.list.offset = offset;
    },
    [SET_COMPANYDB](state, companydb_id) {
        state.list.companydb_id = companydb_id;
    }
}

const getters = {
    getField,
    list: state => state.list,
    
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    models
}